import Swal, { SweetAlertPosition } from "sweetalert2";

export enum AlertTypeEnum {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Question = 'question'
}

const successBackground: string = '#f6ffed';
const errorBackground: string = '#ffe4e0';
const warningBackground: string = '#fffbe6';
const infoBackground: string = '#e6f4ff';
const questionBackground: string = 'ffffff';

export class Alert {
  static basicNotification = (type: AlertTypeEnum, title: string, text: string, position: SweetAlertPosition = 'top') => {
    Swal.fire({
      icon: type,
      showConfirmButton: false,
      background: this.mapBackgroundByType(type),
      title: title,
      text: text,
      position: position,
      toast: true,
      timer: 10000,
      width: '35em',
      customClass: {
        title: 'sweetalert-font-size-title',
        container: 'sweetalert-font-size-message',
        htmlContainer: 'sweetalert-font-size-message'
      }
    })
  }

  static mapBackgroundByType = (type: AlertTypeEnum) => {
    switch(type) {
      case AlertTypeEnum.Success:
        return successBackground;
      case AlertTypeEnum.Error:
        return errorBackground;
      case AlertTypeEnum.Warning:
        return warningBackground;
      case AlertTypeEnum.Info:
        return infoBackground;
      default:
        return questionBackground;
    }
  }

}
